import type { PieceName, VariantName } from "src/api";

const pieceUrl = (pieceName: string) =>
  `${import.meta.env.BASE_URL}models/pieces/${pieceName}.glb`;

export interface PieceDefinition {
  // TODO: becomes a preloaded model asset once that exists
  modelUrl: string;
  scale?: number;
  animations?: string[];
  animationTransitions?: Record<string, (current: string) => string | null>;
  defaultAnimationName?: string;
  moveAnimationName?: string;
  walkAnimationName?: string;
  attackAnimationName?: string;
  hurtAnimationName?: string;
}

export const PIECE_DEFINITIONS: Record<PieceName, PieceDefinition> = {
  pawn: {
    modelUrl: pieceUrl("pawn-primary"),
    scale: 0.25,
    defaultAnimationName: "PAWN_idle_00",
    animations: [
      "PAWN_attack",
      "PAWN_hurt",
      "PAWN_idle_00",
      "PAWN_idle_01",
      "PAWN_idle_02",
      "PAWN_idle_03",
      "PAWN_mining_loop",
      "PAWN_walk_loop"
    ],
    moveAnimationName: "PAWN_walk_loop",
    walkAnimationName: "PAWN_walk_loop",
    attackAnimationName: "PAWN_attack",
    hurtAnimationName: "PAWN_hurt",
    animationTransitions: {
      PAWN_idle_00: () => {
        const rand = Math.random();
        if (rand > 0.33) return "PAWN_idle_00";
        if (rand > 0.25) return "PAWN_idle_01";
        if (rand > 0.15) return "PAWN_idle_02";
        return "PAWN_idle_03";
      },
      PAWN_idle_01: () => {
        return "PAWN_idle_00";
      },
      PAWN_idle_02: () => {
        return "PAWN_idle_00";
      },
      PAWN_idle_03: () => {
        return "PAWN_idle_00";
      }
    }
  },
  knight: {
    modelUrl: pieceUrl("knight-primary"),
    scale: 0.25,
    defaultAnimationName: "KNIGHT_idle_00",
    moveAnimationName: "KNIGHT_jump",
    animations: [
      "KNIGHT_change_unit_dir",
      "KNIGHT_hurt",
      "KNIGHT_idle_00",
      "KNIGHT_idle_01",
      "KNIGHT_jump",
      "KNIGHT_walk",
      "KNIGHT_walk_root"
    ]
  },
  bishop: {
    modelUrl: pieceUrl("bishop-primary"),
    scale: 0.25,
    defaultAnimationName: "BISHOP_Idle",
    moveAnimationName: "BISHOP_walk",
    animations: [
      "BISHOP_attack",
      "BISHOP_hurt",
      "BISHOP_Idle",
      "BISHOP_walk",
      "BISHOP_walk_root"
    ]
  },
  rook: {
    modelUrl: pieceUrl("rook-primary"),
    scale: 0.25,
    defaultAnimationName: "ROOK_Idle_00",
    moveAnimationName: "ROOK_Walk",
    animations: [
      "ROOK_Attack",
      "ROOK_Idle_00",
      "ROOK_Idle_01",
      "ROOK_spawn_unit",
      "ROOK_Walk",
      "ROOK_Walk_root"
    ]
  },
  queen: {
    modelUrl: pieceUrl("queen-primary"),
    scale: 0.25,
    defaultAnimationName: "QUEEN_idle_00",
    moveAnimationName: "QUEEN_walk",
    animations: ["QUEEN_attack", "QUEEN_idle_00", "QUEEN_walk"]
  },
  king: {
    modelUrl: pieceUrl("king-primary"),
    scale: 0.25,
    defaultAnimationName: "KING_idle_00",
    moveAnimationName: "KING_walk",
    animations: [
      "KING_attack",
      "KING_attack_01",
      "KING_hurt",
      "KING_idle_00",
      "KING_walk"
    ]
  },

  // TODO:
  monster: { modelUrl: pieceUrl("queen") }
};

export const VARIANT_PIECE_DEFINITIONS: Partial<
  Record<VariantName, PieceDefinition>
> = {
  marshal: {
    modelUrl: pieceUrl("pawn-marshal"),
    defaultAnimationName: "MARSHAL_anim_Idle_00",
    moveAnimationName: "MARSHAL_walk",
    animations: [
      "MARSHAL_anim_Idle_00",
      "MARSHAL_anim_Idle_01",
      "MARSHAL_walk",
      "MARSHAL_walk_root",
      "PAWN_anim_Attack",
      "PAWN_hurt"
    ]
  },
  dam: { modelUrl: pieceUrl("pawn-dam") }
};

export function pieceDefinitionFor(
  type: PieceName,
  variant?: VariantName
): PieceDefinition {
  if (!variant || variant === "plain") return PIECE_DEFINITIONS[type];
  return VARIANT_PIECE_DEFINITIONS[variant] ?? PIECE_DEFINITIONS[type];
}
